export default function Dashboard() {
  return (
    <div className="flex justify-center items-center w-full h-full">
      <h1 className="text-3xl text-blue-500">
        Wellcome to Modulus Seventeen Admin{" "}
      </h1>
    </div>
  );
}
